import { Injectable, inject } from '@angular/core';
import { ITask } from 'shared';

import { TaskService } from '../task.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface TaskPublishedSocketEvent {
    eventDtoType: 'TaskPublished';
    task: ITask;
}

@Injectable({ providedIn: 'root' })
export class TaskPublishedSocketEventHandler extends BaseSocketEventHandler<TaskPublishedSocketEvent> {
    private taskService = inject(TaskService);

    protected eventDtoType(): string {
        return 'TaskPublished';
    }

    protected async handleEvent(event: TaskPublishedSocketEvent): Promise<void> {
        this.taskService.localUpdate(event.task);
    }
}
